// One-time pdfjs-dist worker setup, shared by every PDF-rendering component
// (SignatureFieldPlacer for tenant field placement, SignPage for the signer
// view). Vite bundles the worker file as its own asset via this `new URL`
// pattern — see https://vite.dev/guide/assets.html#new-url-url-import-meta-url.
import * as pdfjsLib from 'pdfjs-dist'

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()

export { pdfjsLib }
export type { PDFDocumentProxy } from 'pdfjs-dist'
